const getFullSlug = item => {
    if (item._type === 'page') return '/' + item.slug;
    if (item._type === 'externalLink') return item.url;
    if (item._type === 'stavkroaArenaSingleton') return `/venue/${item.slug}`;
    return `/${item._type}/${item.slug}`;
};

export default getFullSlug;
